import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import NrcDecoder from '../components/tools/nrcDecoder/NrcDecoder';
import { Alert, AlertTitle, AlertDescription } from '../components/ui/alert';
import { Info } from 'lucide-react';
import { usePageSeo } from '../hooks/usePageSeo';

const PAGE_TITLE = 'UDS NRC Decoder – Negative Response Code Decoder | AUTOXIUM';
const PAGE_DESCRIPTION = 'Decode UDS Negative Response Codes with meanings, causes, troubleshooting information, and diagnostic examples.';

const NrcDecoderPage = () => {
  usePageSeo(PAGE_TITLE, PAGE_DESCRIPTION);

  return (
    <div className="min-h-screen" data-testid="nrc-decoder-page">
      <PageHero
        eyebrow="Diagnostic Tools"
        title="NRC Decoder"
        description="Decode UDS Negative Response Codes — paste an NRC byte or a full 7F/SID/NRC response and get the meaning, likely causes, and what to check next."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="nrc-decoder-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8 space-y-6">
          <Alert data-testid="nrc-decoder-disclaimer">
            <Info className="h-4 w-4" />
            <AlertTitle className="font-chivo uppercase tracking-tight text-sm">Applicability Note</AlertTitle>
            <AlertDescription>
              NRC meanings and applicability shown here follow ISO 14229-1&apos;s generic
              server negative response codes. Exact applicability to a given service, and
              the meaning of reserved or manufacturer-specific codes, can vary by ISO
              14229-1 edition and by OEM diagnostic specification — always cross-check
              against the target ECU&apos;s own diagnostic specification before relying on
              this for real vehicle diagnostics.
            </AlertDescription>
          </Alert>

          <NrcDecoder />
          <ToolGuideCta guidePath="/tools/diagnostic/nrc-decoder/guide" toolName="NRC Decoder" />
        </div>
      </section>
    </div>
  );
};

export default NrcDecoderPage;
